import { FileText, FileType2, Sheet } from "lucide-react";
import { api } from "@/lib/api";

export const FILE_ICON = { pdf: FileText, docx: FileType2, xlsx: Sheet };
export const FILE_STYLE = { pdf: "bg-rose-50 text-rose-700", docx: "bg-sky-50 text-sky-700", xlsx: "bg-emerald-50 text-emerald-700" };
export const FORM_WRITERS = ["admin", "regional_manager"];

export const FileTypeBadge = ({ type }) => {
  const Icon = FILE_ICON[type] || FileText;
  return <span className={`inline-flex items-center gap-1 rounded-full px-2 py-0.5 text-[10px] font-bold uppercase tracking-wider ${FILE_STYLE[type] || ""}`}><Icon className="h-3 w-3" />{type}</span>;
};

export async function downloadForm(form) {
  const { data } = await api.get(`/forms/${form.id}/file`, { params: { download: true }, responseType: "blob" });
  const url = URL.createObjectURL(data);
  const a = document.createElement("a");
  a.href = url;
  a.download = form.file_name || `${form.title}.${form.file_type}`;
  a.click();
  setTimeout(() => URL.revokeObjectURL(url), 2000);
}

export const asList = (d) => (Array.isArray(d) ? d : d?.items || []);
